import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  inheritAttrs: false
}

import { PropType } from '@nuxtjs/composition-api'

type Style = 'style_01' | 'style_02';
type Size = 'small' | 'medium' | 'xlarge';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ButtonPrimary',
  props: {
  buttonStyle: {
    type: String as PropType<Style>,
    default: ''
  },
  buttonSize: {
    type: String as PropType<Size>,
    default: ''
  }
},
  setup(__props) {



return { __sfc: true, }
}

})